import { SVGProps } from 'react';

const SvgBellSlash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2s-6.3 25.5 4.1 33.7l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L542.6 400c2.7-7.8 1.3-16.5-3.9-23l-14.9-18.6c-28.3-35.5-43.8-79.6-43.8-125V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9c-43.9 7-81.5 32.7-104.4 68.7L38.8 5.1zm182.9 143.3C239.6 117.1 273.3 96 312 96h16c57.4 0 104 46.6 104 104v33.4c0 32.7 6.4 64.8 18.7 94.5l-229-179.5zM406.2 416l-60.9-48h-177c21.2-32.8 34.4-70.3 38.4-109.1L160 222.1v11.4c0 45.4-15.5 89.5-43.8 124.9L101.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S110.8 416 120 416h286.2zM384 448H256c0 17 6.7 33.3 18.7 45.3S303 512 320 512s33.3-6.7 45.3-18.7S384 465 384 448z" />
  </svg>
);
export default SvgBellSlash;
